import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-lazy-image',
  templateUrl: './lazy-image.component.html',
  styleUrls: ['./lazy-image.component.scss']
})
export class LazyImageComponent {

  @Input() class;
  @Input() alt;
  @Input() defaultImagePassed: 'https://www.placecage.com/1000/1000';
  @Input() imagePassed = 'https://images.unsplash.com/photo-1443890923422-7819ed4101c0?fm=jpg';
  @Input() offsetPassed = 100;

}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/lazy-image/lazy-image.component.ts